import React from "react";
import { Typography, Button, Spin } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { DragDropContext } from "@hello-pangea/dnd";
import CRMColumn from "./CRMColumn";
import CreateRequirementModal from "./CreateRequirementModal";
import ConversationDrawer from "./ConversationDrawer";
import useCRM from "../utils/useCRM.js";
import "./CRMPage.css";

const { Title } = Typography;

export const COLUMNS = [
  { key: "requirement", label: "Requirement", color: "#3699FF" },
  { key: "in_discussion", label: "In Discussion", color: "#13487D" },
  {
    key: "business_conversion",
    label: "Business Conversion",
    color: "#27AE60",
  },
];

export default function CRMPage() {
  // Replace with your auth source:
  // Redux:   const currentUser = useSelector(state => state.auth.user);
  // Context: const { user: currentUser } = useContext(AuthContext);
  const currentUser = JSON.parse(localStorage.getItem("userDetails") || "{}");
  const {
    columns,
    boardLoading,
    users,
    unreadCounts,
    modalOpen,
    setModalOpen,
    submitting,
    handleCreateRequirement,
    handleDragEnd,
    handleDeleteRequirement,
    drawerCard,
    openDrawer,
    closeDrawer,
    messages,
    messagesLoading,
    sendingMessage,
    handleSendMessage,
    handleDeleteMessage,
    handleMoveColumn,
    handleUpdateDescription,
  } = useCRM(currentUser);

  const totalCards = Object.values(columns).reduce(
    (sum, col) => sum + col.length,
    0,
  );

  return (
    <div className="crm-page">
      {/* Header */}
      <div className="crm-header">
        <div className="crm-header-left">
          <Title level={4} className="crm-title">
            CRM Pipeline
          </Title>
          <span className="crm-subtitle">{totalCards} total requirements</span>
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setModalOpen(true)}
          className="crm-add-btn"
        >
          New Requirement
        </Button>
      </div>

      {/* Board */}
      {boardLoading ? (
        <div className="crm-board-loading">
          <Spin size="large" tip="Loading pipeline..." />
        </div>
      ) : (
        <DragDropContext onDragEnd={handleDragEnd}>
          <div className="crm-board">
            {COLUMNS.map((col) => (
              <CRMColumn
                key={col.key}
                column={col}
                unreadCounts={unreadCounts}
                cards={columns[col.key] || []}
                allColumns={COLUMNS}
                onCardClick={openDrawer}
                onMoveColumn={handleMoveColumn}
                onDeleteCard={handleDeleteRequirement}
              />
            ))}
          </div>
        </DragDropContext>
      )}

      {/* Create Modal */}
      <CreateRequirementModal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onSubmit={handleCreateRequirement}
        users={users}
        currentUser={currentUser}
        submitting={submitting}
      />

      {/* Conversation Drawer */}
      <ConversationDrawer
        card={drawerCard}
        currentUser={currentUser}
        messages={messages}
        messagesLoading={messagesLoading}
        sendingMessage={sendingMessage}
        onClose={closeDrawer}
        onSend={handleSendMessage}
        onDeleteMessage={handleDeleteMessage}
        allColumns={COLUMNS}
        onMoveColumn={handleMoveColumn}
        onUpdateDescription={handleUpdateDescription}
      />
    </div>
  );
}
